module.exports = __webpack_public_path__ + "static/media/ch3.e8f6ff21.jpg";